exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-list{position:absolute;top:0;width:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;gap:10px;z-index:9999;pointer-events:none}.alert-list .common-alert{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;gap:10px;position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;pointer-events:all}.alert-list .common-alert button{position:relative;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/alert/AlertList.scss
// module id = 6351
// module chunks = 0